module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    staticClass: "canvas-interactive",
    attrs: {
      "id": _vm.name,
      "width": "512",
      "height": "512"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40fe0bdf!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/GradientCanvas.vue
// module id = 180
// module chunks = 2